/*
 *  Created by SGiri 02/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Dashboard } from '~config/model/dashbord';
import { DashboardService } from '~config/services/dashboard.service';

@Component({
  selector: 'app-new-kpi',
  templateUrl: './new-kpi.component.html',
  styleUrls: ['./new-kpi.component.css']
})
export class NewKpiComponent implements OnInit {

  selectedKpiType:string;
  selectedDecimalPlace:string;
  locations: string[];
  globalDashboards: Dashboard[];
  reports = new Array();
  scoreCardReports = new Array();
  decimalPlaces:string[];
  excelformats:string[];
  form: FormGroup;

  constructor(private service: DashboardService, private router: Router) {
    this.globalDashboards = service.globalDashboards;
  }

  ngOnInit() {
    this.form = new FormGroup({
      dashboardId: new FormControl('', [Validators.required]),
      name: new FormControl('', Validators.required),
      selection: new FormControl('', Validators.required),
      reportId: new FormControl('', Validators.required),
      scorecardReportId: new FormControl('', Validators.required),
      releaseVersion: new FormControl('', Validators.required),
      kpiType: new FormControl('', Validators.required),
      decimalPlace: new FormControl('', Validators.required),
      excelFormat: new FormControl('', Validators.required),
      starReportEnabled: new FormControl('', Validators.required),
      starSortCriteria: new FormControl('', Validators.required),

      sort: new FormControl('-1'),
      userId: new FormControl({ value: '*', disabled: true }),

    })
  }

  save() {
    this.service.saveNewKpi(this.form.value).toPromise().then(() => {
      this.router.navigate(['dashboard'])
    }).catch(error => {
      console.log(error);
    });
  }

  onSelectionChange(selected) {
    this.service.getReportAndScoreCardReportIds(selected.value).subscribe((data: any[]) => {
      data = data;
      this.reports = data[0];
      this.scoreCardReports = data[1];
    });

  }

  onKPITypeChange(){

    if(this.selectedKpiType==='PERCENTAGE'){
      this.decimalPlaces=['0','1','2'];
    }else if(this.selectedKpiType==='COUNT'){
      this.decimalPlaces=['0'];
    }else if(this.selectedKpiType==='CURRENCY'){
      this.decimalPlaces=['0','1','2'];
    }
  }

  onDecimalChange(){
    if(this.selectedDecimalPlace==='0'){
      this.excelformats=['#,##0','[$$-409]#,##0;([$$-409]#,##0)'];
    }else if(this.selectedDecimalPlace==='1'){
      this.excelformats=['#,##0','#,##0%;(#,##0%)','#,##0.0','#,##0.0%','#,##0.0%;(#,##0.0%)','#,##0.0%;-#,##0.0%', '#,##0.0;-#,##0.0','#,##0.00%', '#,##0.00%;-#,##0.00%','#,##0.00;-#,##0.00','#,##0;-#,##0','[$$-409]#,##0.0;([$$-409]#,##0.0)','[$$-409]#,##0.00;([$$-409]#,##0.00)', '[$$-409]#,##0.00;-[$$-409]#,##0.00','[$$-409]#,##0;([$$-409]#,##0)', '\\[$$-409\\]\\#\\,\\#\\#0\\;\\\\\\(\\[$$-409\]\\#\\,\\#\\#0\\\\\\);\\0022$0\\0022'];
    }else if(this.selectedDecimalPlace==='2'){
      this.excelformats=['[$$-409]#,##0;([$$-409]#,##0)','[$$-409]#,##0.00;([$$-409]#,##0.00)'];
    }
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/new-kpi/new-kpi.component.ts